import OpenPopup from '../popup';

export default function CardPopups() {
    document.querySelectorAll('.open-popup').forEach(card => {
        card.addEventListener('click', () => {
            if (card.getAttribute('data-id')) {
                OpenPopup(card.getAttribute('data-id'));
            }
        });
    });
}
